// Blog post hero: back link, "From the blog" eyebrow, title, deck, author row.
import { Link } from "react-router";

import ryanIcon from "../assets/ryan-icon.png";

export function BlogHero() {
  return (
    <section className="px-[clamp(24px,5vw,80px)] pt-12 pb-14">
      <div className="mx-auto max-w-[760px]">
        <Link
          to="/"
          className="mb-4 inline-flex items-center gap-1.5 text-sm font-medium text-secondary no-underline hover:text-indigo-600"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 12H5M12 19l-7-7 7-7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back
        </Link>

        <div className="mb-6 flex">
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.04em] text-indigo-700">
            From the blog
          </div>
        </div>

        <h1 className="font-companion tracking-[-0.01em] mb-6 text-[clamp(40px,5.5vw,64px)] font-bold leading-[1.05] tracking-[-0.03em] text-primary [text-wrap:balance]">
          Life is better with Companions
        </h1>

        <p className="mb-9 font-companion text-[22px] leading-[1.5] text-secondary [text-wrap:pretty]">
          This May, the team that brought AI scribing to veterinary medicine
          will launch an advanced new veterinary artificial intelligence. A
          digital brain for your clinic.
        </p>

        <div className="flex items-center gap-3.5 border-t border-grindigo-100 pt-6">
          <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full">
            <img
              src={ryanIcon}
              alt="Ryan Gallagher"
              className="block h-full w-full object-cover"
            />
          </div>
          <div>
            <div className="text-[15px] font-semibold text-primary">
              Ryan Gallagher
            </div>
            <div className="text-[13px] text-secondary">
              Co-founder, Scribenote · April 2026
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
